<template>
  <div class="container">
    <section
      class="footer-icons"
      :class="{
        'footer-icons--overlay': isOverlayMode,
        'footer-icons--solid': !isOverlayMode,
      }"
    >
      <div class="footer-icons__group footer-icons__group--call">
        <a href="tel:+33787185918">
          <p class="blue">APPEL</p>
          <div class="allIcons">
            <img
              class="footer-icons__icon footer-icons__icon--default"
              src="@/assets/icons/icons-appel.webp"
              alt="icon-phone"
              loading="lazy"
            />
            <img
              class="footer-icons__icon footer-icons__icon--mobile"
              src="@/assets/icons/icons-appel-yellow.webp"
              alt="icon-phone"
              loading="lazy"
            />
          </div>
        </a>
      </div>
      <div class="footer-icons__group footer-icons__group--separator mx-2">
        <div class="allIcons">
          <div class="pipe"></div>
        </div>
      </div>
      <div class="footer-icons__group footer-icons__group--sms">
        <a href="sms:+33787185918">
          <p class="yellow">SMS</p>
          <div class="allIcons">
            <img
              class="footer-icons__icon footer-icons__icon--default"
              src="@/assets/icons/icons-sms.webp"
              alt="icon-sms"
            />
            <img
              class="footer-icons__icon footer-icons__icon--mobile"
              src="@/assets/icons/icons-sms-blue.webp"
              alt="icon-sms"
            />
          </div>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "BtnCallNav",
  props: {
    isOverlayMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-icons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 5px;
  &--overlay {
    .footer-icons__group {
      a {
        .yellow,
        .blue {
          color: rgba(255, 255, 255, 0.94);
        }
      }

      img {
        filter: brightness(0) invert(1);
        opacity: 0.88;
      }

      .allIcons .pipe {
        background: rgba(255, 255, 255, 0.32);
      }
    }
  }

  &--solid {
    .footer-icons__group {
      a {
        .yellow {
          color: $color-secondary;
        }

        .blue {
          color: $color-primary;
        }
      }
    }
  }

  &__group {
    text-align: center;
    a {
      transition: 0.5s;
      text-decoration: none;
      & :hover {
        scale: 94%;
      }
      & .yellow {
        color: $color-secondary;
      }
      & .blue {
        color: $color-primary;
      }
    }
    & img {
      width: 35px;
      transition: filter 0.25s ease, opacity 0.25s ease;
    }
    & p {
      font-size: 0.7em;
      text-align: center;
      margin-bottom: 0px;
      font-family: "adam";
      transition: color 0.25s ease;
    }
    & .allIcons {
      width: fit-content;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      & .pipe {
        width: 1.5px;
        height: 40px;
        @include black-gradient;
        transition: background 0.25s ease;
      }
    }
  }

  &__icon--mobile {
    display: none;
  }
}

@media screen and (max-width: 991.98px) {
  .footer-icons {
    align-items: center;
    padding: 10px 0 14px;

    &__group {
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        min-width: 104px;
        min-height: 40px;
        padding: 0 16px;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 10px 18px rgba(0, 42, 84, 0.12);
      }

      &:not(.footer-icons__group--separator) .allIcons {
        display: flex;
        width: auto;
        border-radius: 0;
      }

      .footer-icons__icon--default {
        display: none;
      }

      .footer-icons__icon--mobile {
        display: block;
        width: 16px;
        height: 16px;
      }

      p {
        margin: 0;
        font-size: 0.72rem;
        letter-spacing: 0.14em;
        line-height: 1;
      }
    }

    &__group--call a {
      flex-direction: row-reverse;
    }

    &__group--sms a {
      flex-direction: row;
    }

    &__group--separator {
      .allIcons {
        display: flex;
      }

      .allIcons .pipe {
        width: 1px;
        height: 30px;
      }
    }

    .footer-icons__group:not(.footer-icons__group--separator) img {
      filter: brightness(0) invert(1);
      opacity: 1;
    }

    &--solid {
      .footer-icons__group:first-child a {
        background: $color-primary;
      }

      .footer-icons__group:first-child .blue {
        color: $color-secondary;
      }

      .footer-icons__group:last-child a {
        background: $color-secondary;
      }

      .footer-icons__group:last-child .yellow {
        color: $color-primary;
      }
    }

    &--overlay {
      .footer-icons__group a {
        background: rgba(255, 255, 255, 0.08);
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
      }

      .footer-icons__group--separator .allIcons .pipe {
        background: rgba(255, 255, 255, 0.32);
      }
    }
  }
}
</style>
